import { useEffect, useRef, memo } from "react";
import { getCurrencySymbolCrypto } from "../../../helper/GetCurrencySymbolCrypto";

function TechnicalAnalysis({ activeAccount, theme }) {
  const container = useRef();

  useEffect(() => {
    if (!activeAccount || !container.current || !theme) return;

    const timeout = setTimeout(() => {
      container.current.innerHTML = "";

      const symbol = getCurrencySymbolCrypto(activeAccount.currency_code);

      const script = document.createElement("script");
      script.src =
        "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js";
      script.type = "text/javascript";
      script.async = true;
      script.onerror = (e) => {
        console.error("TradingView script load error:", e);
      };
      script.innerHTML = `
        {
          "colorTheme": "${theme}",
          "displayMode": "single",
          "isTransparent": false,
          "locale": "en",
          "interval": "1m",
          "disableInterval": false,
          "width": "100%",
          "height": 400,
          "symbol": "${symbol}",
          "showIntervalTabs": true
        }`;
      if (container.current) {
        container.current.appendChild(script);
      }
    }, 0);
    return () => clearTimeout(timeout); // Clean up
  }, [activeAccount, theme]);

  return (
    <div className="w-full rounded-sm border border-background-surface shadow-box-shadow" ref={container}>
      <div className="tradingview-widget-container__widget"></div>
    </div>
  );
}

export default memo(TechnicalAnalysis);
